import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import '../css/WelcomePage.css';
import { Tooltip } from 'react-tooltip';
import { motion, AnimatePresence } from 'framer-motion';
import API from '../services/api';
import { buildCategoriesFromNavigation } from '../config/navigation';
import { Carousel } from 'react-responsive-carousel';
import "react-responsive-carousel/lib/styles/carousel.min.css";
import CompactAttendanceBar from '../components/attendance/CompactAttendanceBar';
import '../styles/ResizeObserverFix.css';
import { initializeResizeObserverFix } from '../utils/resizeObserverFix';

// Base64 encoded small car images for fallback
const carBase64_1 = "data:image/jpeg;base64,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";
const carBase64_2 = "data:image/jpeg;base64,/9j/4AAQSkZJRgABAQEAYABgAAD//gA7Q1JFQVRPUjogZ2QtanBlZyB2MS4wICh1c2luZyBJSkcgSlBFRyB2NjIpLCBxdWFsaXR5ID0gOTAK/9sAQwADAgIDAgIDAwMDBAMDBAUIBQUEBAUKBwcGCAwKDAwLCgsLDQ4SEA0OEQ4LCxAWEBETFBUVFQwPFxgWFBgSFBUU/9sAQwEDBAQFBAUJBQUJFA0LDRQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQU/8AAEQgAKABQAwEiAAIRAQMRAf/EAB8AAAEFAQEBAQEBAAAAAAAAAAABAgMEBQYHCAkKC//EALUQAAIBAwMCBAMFBQQEAAABfQECAwAEEQUSITFBBhNRYQcicRQygZGhCCNCscEVUtHwJDNicoIJChYXGBkaJSYnKCkqNDU2Nzg5OkNERUZHSElKU1RVVldYWVpjZGVmZ2hpanN0dXZ3eHl6g4SFhoeIiYqSk5SVlpeYmZqio6Slpqeoqaqys7S1tre4ubrCw8TFxsfIycrS09TV1tfY2drh4uPk5ebn6Onq8fLz9PX29/j5+v/EAB8BAAMBAQEBAQEBAQEAAAAAAAABAgMEBQYHCAkKC//EALURAAIBAgQEAwQHBQQEAAECdwABAgMRBAUhMQYSQVEHYXETIjKBCBRCkaGxwQkjM1LwFWJy0QoWJDThJfEXGBkaJicoKSo1Njc4OTpDREVGR0hJSlNUVVZXWFlaY2RlZmdoaWpzdHV2d3h5eoKDhIWGh4iJipKTlJWWl5iZmqKjpKWmp6ipqrKztLW2t7i5usLDxMXGx8jJytLT1NXW19jZ2uLj5OXm5+jp6vLz9PX29/j5+v/aAAwDAQACEQMRAD8A+t/FXxA0/wAK6lFZ3Ed1K8kJmDQqpA5IxksM9PSubuPjlpMcmI7PUZVzjcFRc/TLZrJ+Pmnm68X6XGrFQ1gQSOo/eP8A4V5ZJZyRSFJEZHXqrDBFfG4jNcRTxEqcXZJ2PtcPl1CdCNRq7aue0f8AC7dJ/wCfHUP++o//AIqj/hduk/8APjqH/fUf/wAVXjP2WT/nm35Uj2cqIzlGCqMk4rD+0sV/N+Bv/ZtD+U9m/wCF26T/AM+Oof8AfUf/AMVR/wALt0n/AJ8dQ/76j/8Aiq8a+zS/881/Kk+zy/8APNvyqfrWK/m/AP7Nofynrf8Awu3Sf+fHUP8AvqP/AOKo/wCF26T/AM+Oof8AfUf/AMVXkv2aX/nmv5UfZpf+ea/lR9axX834B/ZtD+U9a/4XbpP/AD46h/31H/8AFUf8Lt0n/nx1D/vqP/4qvJfs0v8AzzX8qPs0v/PNfyo+tYr+b8A/s2h/Keu/8Lt0n/nx1D/vqP8A+KrQ0n4raXrGpW9lFa3yyzuEUuEAz+Lc14P9ml/55r+VdN8JIpJPiJpAjRmxMWOB/dNaU8ZiJTUXPVmeIy+hGm5qOqR6P8Zf+R80/wD68B/6G9eXV6j8Zf8AkfNP/wCvAf8Aob15dXz2N/3qp6n0WC/gQ9Aooorls9AKKKKACiiigAooooAK6f4T/wDI/wCkf9dW/wDQTXMV0/wn/wCR/wBI/wCurf8AoJrfD/xoev5HPiv4M/R/kdn8Zf8AkfNP/wCvAf8Aob15dXqPxl/5HzT/APrwH/ob15dXVjf96qep5+C/gQ9AooorA7AooooAKKKKACiiigArp/hP/wAj/pH/AF1b/wBBNcxXT/Cf/kf9I/66t/6Ca3w/8aHr+Rz4r+DP0f5HZ/GX/kfNP/68B/6G9eXV6j8Zf+R80/8A68B/6G9eXV1Y3/eqnqefgv4EPQKKKKwOwKKKKACiiigAooooAK6f4T/8j/pH/XVv/QTXMVLaXc1jdxXNtK8M8TB0kQ4ZSOhBrSnNwmpLdGdWCnBxezPYvjL/AMj5p/8A14D/ANDevLq9I8afEjw/4r0G3sYdPvoZVnEpaaRCBgEYxg+tcF/wiGr/APPh/wCRI/8A4qvQxVWFbESnB3TPMwlKdHDxhNWaRztFdF/wiGr/APPh/wCRI/8A4qj/AIRDVv8Anw/8iR//ABVc3t4dzoujnqK6L/hENW/58P8AyJH/APFUf8Ihq3/Ph/5Ej/8Aiqfton3Qujnq0PDWgXHibXrTSrZlSW4cgO/3UUAksfYAE1D/AMIhq3/Ph/5Ej/8Aiqtad4m0/wAJeHNQ1Cxs7+5vFYQWvmSIFLkZZjgHgD9TVwlGTtF3ZE4ySvJWRqf8KQ8Qf89tN/7+P/8AEVleIPh5qvhjTjd3jW0sQcITbsxK5/DpXMf8Jhrf/QQu/wDv61H/AAmGt/8AQQu/+/rVbqYdvWRFqOIXQ//Z";

const WelcomePage = ({ isAuthenticated, user }) => {
  const navigate = useNavigate();
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');
  const [searchResults, setSearchResults] = useState([]);
  const [activeTab, setActiveTab] = useState('dashboard');
  const searchInputRef = useRef(null);
  const [stats, setStats] = useState({
    totalVehicles: 0,
    todayAppointments: 0,
    inUseVehicles: 0,
    inMaintenanceVehicles: 0
  });
  const [isSearching, setIsSearching] = useState(false);
  const [favorites, setFavorites] = useState([]);
  const [toastMessage, setToastMessage] = useState('');
  const [showToast, setShowToast] = useState(false);

  // Show toast notification
  const showToastNotification = (message) => {
    setToastMessage(message);
    setShowToast(true);
    setTimeout(() => {
      setShowToast(false);
    }, 3000);
  };

  // Load favorites from localStorage on component mount
  useEffect(() => {
    const savedFavorites = localStorage.getItem('userFavorites');
    if (savedFavorites) {
      try {
        const parsedFavorites = JSON.parse(savedFavorites);
        setFavorites(parsedFavorites);
      } catch (error) {
        console.error('Error parsing favorites from localStorage:', error);
        setFavorites([]);
      }
    }
  }, []);

  // Initialize ResizeObserver fixes
  useEffect(() => {
    initializeResizeObserverFix();
  }, []);

  // Save favorites to localStorage whenever favorites change
  useEffect(() => {
    localStorage.setItem('userFavorites', JSON.stringify(favorites));
  }, [favorites]);

  // Function to toggle favorite status
  const toggleFavorite = (item) => {
    setFavorites(prevFavorites => {
      const isAlreadyFavorite = prevFavorites.some(fav => fav.path === item.path);

      if (isAlreadyFavorite) {
        // Remove from favorites
        showToastNotification(`Đã xóa "${item.title}" khỏi truy cập nhanh`);
        return prevFavorites.filter(fav => fav.path !== item.path);
      } else {
        // Add to favorites (max 12 items)
        if (prevFavorites.length >= 12) {
          // Remove the oldest favorite and add the new one
          showToastNotification(`Đã thêm "${item.title}" vào truy cập nhanh (thay thế mục cũ nhất)`);
          return [...prevFavorites.slice(1), item];
        } else {
          showToastNotification(`Đã thêm "${item.title}" vào truy cập nhanh`);
          return [...prevFavorites, item];
        }
      }
    });
  };

  // Check if an item is favorited
  const isFavorited = (item) => {
    return favorites.some(fav => fav.path === item.path);
  };

  // Slider data with fallback gradient backgrounds, base64 images, and action buttons
  const sliderData = [
    {
      // Sử dụng nhiều cách đường dẫn khác nhau để đảm bảo ít nhất một cách hoạt động
      image: `https://images.unsplash.com/photo-1449965408869-eaa3f722e40d?q=80&w=1920&auto=format&fit=crop`,
      // Đường dẫn tương đối từ thư mục public
      imageAlt: 'https://images.unsplash.com/photo-1449965408869-eaa3f722e40d?q=80&w=1920&auto=format&fit=crop',
      // Đường dẫn tuyệt đối
      imageAbs: 'https://images.unsplash.com/photo-1449965408869-eaa3f722e40d?q=80&w=1920&auto=format&fit=crop',
      // Base64 encoded image as fallback
      imageBase64: carBase64_1,
      title: 'Quản Lý Xe Hiệu Quả',
      description: 'Tối ưu hóa việc sử dụng xe và quản lý tài nguyên',
      gradient: 'linear-gradient(135deg, #1b3f85 0%, #2f6bd8 100%)',
      buttonText: 'Xem Danh Sách Xe',
      buttonLink: '/vehicle-management'
    },
    {
      image: `https://images.unsplash.com/photo-1560179707-f14e90ef3623?q=80&w=1920&auto=format&fit=crop`,
      imageAlt: 'https://images.unsplash.com/photo-1560179707-f14e90ef3623?q=80&w=1920&auto=format&fit=crop',
      imageAbs: 'https://images.unsplash.com/photo-1560179707-f14e90ef3623?q=80&w=1920&auto=format&fit=crop',
      imageBase64: carBase64_2,
      title: 'Nhật Ký Công Việc',
      description: 'Cập nhật và Nhật Ký Công Việc theo thời gian thực',
      gradient: 'linear-gradient(135deg, #0c222a 0%, #16404d 50%, #1d5f7c 100%)',
      buttonText: 'Theo Dõi Công Việc',
      buttonLink: '/work-journal'
    }
  ];

  const handleCardClick = (path) => {
    navigate(path);
  };

  // Fetch statistics from database
  useEffect(() => {
    const useDefaultStats = () => {
      const fallbackStats = {
        totalVehicles: 24,
        todayAppointments: 8,
        inUseVehicles: 12,
        inMaintenanceVehicles: 3
      };
      console.log("Using fallback stats due to error:", fallbackStats);
      setStats(fallbackStats);
    };

    const fetchStats = async () => {
      const userId = user?.id || user?._id;
      if (!userId || !user?.role) {
        console.log("No authenticated user for stats, using fallback.");
        useDefaultStats();
        return;
      }

      try {
        const userRole = user.role;
        console.log("Fetching stats for user role:", userRole);

        // Sửa từ /vehicles/count thành /cars
        console.log("Fetching vehicle statistics...");
        let totalVehicles = 0;
        let inUseVehicles = 0;
        let inMaintenanceVehicles = 0;

        try {
          // Lấy tất cả xe và đếm theo trạng thái
          const allVehiclesResponse = await API.get(`/cars`);
          console.log("All vehicles response:", allVehiclesResponse.data);

          if (Array.isArray(allVehiclesResponse.data)) {
            totalVehicles = allVehiclesResponse.data.length;
            inUseVehicles = allVehiclesResponse.data.filter(v => v.status === 'IN_USE').length;
            inMaintenanceVehicles = allVehiclesResponse.data.filter(v => v.status === 'MAINTENANCE').length;
          }
        } catch (vehicleError) {
          console.error("Error fetching vehicles:", vehicleError);
        }

        const today = new Date().toISOString().split('T')[0];
        let todayAppointments = 0;

        try {
          const appointmentsResponse = await API.get(`/requests?date=${today}`);
          console.log("Today's appointments response:", appointmentsResponse.data);
          if (Array.isArray(appointmentsResponse.data)) {
            todayAppointments = appointmentsResponse.data.length;
          }
        } catch (appointmentError) {
          console.error("Error fetching appointments:", appointmentError);
        }

        const newStats = {
          totalVehicles: totalVehicles || 0,
          todayAppointments: todayAppointments || 0,
          inUseVehicles: inUseVehicles || 0,
          inMaintenanceVehicles: inMaintenanceVehicles || 0
        };

        console.log("Setting new stats:", newStats);
        setStats(newStats);
      } catch (error) {
        console.error('Error fetching statistics:', error);
        useDefaultStats();
      }
    };

    fetchStats();
  }, [user]);

  // Hàm loại bỏ dấu tiếng Việt
  const removeDiacritics = (str) => {
    if (!str) return '';
    return str.normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/đ/g, 'd')
      .replace(/Đ/g, 'D');
  };

  // Search functionality
  useEffect(() => {
    const searchFunctions = async () => {
      if (searchTerm.trim() === '') {
        setSearchResults([]);
        setIsSearching(false);
        return;
      }

      setIsSearching(true);

      try {
        // Search across all categories and functions
        const results = [];
        const searchTerms = searchTerm.toLowerCase().split(/\s+/).filter(term => term.length > 0);
        // Tạo thêm các phiên bản không dấu của từ khóa tìm kiếm
        const normalizedSearchTerms = searchTerms.map(term => removeDiacritics(term));

        // Lấy danh sách categories dựa trên role của user (dùng cấu hình chung)
        const roleCategories = buildCategoriesFromNavigation(user?.role || 'EMPLOYEE');

        // Hàm tính điểm phù hợp cho mỗi item
        const calculateRelevanceScore = (item, terms, normalizedTerms) => {
          if (!item || !item.title || !item.description) {
            return 0; // Trả về 0 nếu item không hợp lệ hoặc thiếu thuộc tính
          }

          let score = 0;
          const title = item.title.toLowerCase();
          const description = item.description.toLowerCase();
          // Tạo phiên bản không dấu của tiêu đề và mô tả
          const normalizedTitle = removeDiacritics(title);
          const normalizedDescription = removeDiacritics(description);

          // Tìm kiếm với cả từ khóa có dấu
          terms.forEach(term => {
            // Tăng điểm nếu từ khóa xuất hiện trong tiêu đề
            if (title.includes(term)) {
              score += 3;
              // Thêm điểm nếu từ khóa xuất hiện ở đầu tiêu đề
              if (title.startsWith(term)) score += 2;
            }

            // Tăng điểm nếu từ khóa xuất hiện trong mô tả
            if (description.includes(term)) {
              score += 1;
            }

            // Tăng điểm nếu từ khóa khớp chính xác với tiêu đề
            if (title === term) score += 5;
          });

          // Tìm kiếm với từ khóa không dấu
          normalizedTerms.forEach((normalizedTerm, index) => {
            const term = terms[index]; // Từ khóa gốc tương ứng

            // Tăng điểm nếu từ khóa không dấu xuất hiện trong tiêu đề không dấu
            if (normalizedTitle.includes(normalizedTerm)) {
              // Điểm thấp hơn một chút so với khớp chính xác có dấu
              score += 2.5;
              // Thêm điểm nếu từ khóa không dấu xuất hiện ở đầu tiêu đề không dấu
              if (normalizedTitle.startsWith(normalizedTerm)) score += 1.5;
            }

            // Tăng điểm nếu từ khóa không dấu xuất hiện trong mô tả không dấu
            if (normalizedDescription.includes(normalizedTerm)) {
              score += 0.8;
            }

            // Tăng điểm nếu từ khóa không dấu khớp chính xác với tiêu đề không dấu
            if (normalizedTitle === normalizedTerm) score += 4;
          });

          return score;
        };

        roleCategories.forEach(category => {
          if (category && category.items && Array.isArray(category.items)) {
            // Match trên tiêu đề danh mục (section-title)
            const categoryTitle = (category.title || '').toLowerCase();
            const categoryTitleNormalized = removeDiacritics(categoryTitle);
            const matchesCategoryAccent = searchTerms.some(term => categoryTitle.includes(term));
            const matchesCategoryNonAccent = normalizedSearchTerms.some(term => categoryTitleNormalized.includes(term));
            const matchedCategory = matchesCategoryAccent || matchesCategoryNonAccent;
            const categoryBonus = matchesCategoryAccent ? 2 : (matchesCategoryNonAccent ? 1.2 : 0);

            category.items.forEach(item => {
              if (!item || !item.title || !item.description) {
                return; // Bỏ qua item không hợp lệ
              }

              // Tính điểm phù hợp với cả từ khóa có dấu và không dấu
              let score = calculateRelevanceScore(item, searchTerms, normalizedSearchTerms);
              // Cộng điểm nếu tiêu đề danh mục khớp với từ khóa
              score += categoryBonus;

              // Nếu có ít nhất một từ khóa khớp (điểm > 0), thêm vào kết quả
              if (score > 0) {
                results.push({
                  ...item,
                  category: category.title,
                  relevanceScore: score
                });
              } else {
                const title = item.title.toLowerCase();
                const description = item.description.toLowerCase();
                const normalizedTitle = removeDiacritics(title);
                const normalizedDescription = removeDiacritics(description);

                // Kiểm tra từng từ trong tiêu đề và mô tả
                const titleWords = title.split(/\s+/);
                const descriptionWords = description.split(/\s+/);
                const normalizedTitleWords = normalizedTitle.split(/\s+/);
                const normalizedDescriptionWords = normalizedDescription.split(/\s+/);

                let matchFound = false;

                // Kiểm tra với từ khóa có dấu
                searchTerms.forEach(term => {
                  titleWords.forEach(word => {
                    if (word.startsWith(term)) {
                      matchFound = true;
                    }
                  });

                  descriptionWords.forEach(word => {
                    if (word.startsWith(term)) {
                      matchFound = true;
                    }
                  });

                  // Kiểm tra xem từ khóa có là một phần của từ nào trong tiêu đề hoặc mô tả không
                  if (title.includes(term) || description.includes(term)) {
                    matchFound = true;
                  }
                });

                // Kiểm tra với từ khóa không dấu
                normalizedSearchTerms.forEach(normalizedTerm => {
                  normalizedTitleWords.forEach(word => {
                    if (word.startsWith(normalizedTerm)) {
                      matchFound = true;
                    }
                  });

                  normalizedDescriptionWords.forEach(word => {
                    if (word.startsWith(normalizedTerm)) {
                      matchFound = true;
                    }
                  });

                  // Kiểm tra xem từ khóa không dấu có là một phần của từ nào trong tiêu đề hoặc mô tả không dấu không
                  if (normalizedTitle.includes(normalizedTerm) || normalizedDescription.includes(normalizedTerm)) {
                    matchFound = true;
                  }
                });

                // Nếu chưa khớp theo item nhưng tiêu đề danh mục khớp, vẫn cho vào kết quả với điểm thấp
                if (!matchFound && matchedCategory) {
                  matchFound = true;
                }

                if (matchFound) {
                  results.push({
                    ...item,
                    category: category.title,
                    relevanceScore: matchedCategory ? (matchesCategoryAccent ? 1.5 : 1) : 0.5 // Ưu tiên nhẹ nếu khớp theo tiêu đề danh mục
                  });
                }
              }
            });
          }
        });

        // Sắp xếp kết quả theo điểm phù hợp (cao đến thấp)
        results.sort((a, b) => b.relevanceScore - a.relevanceScore);

        // Loại bỏ các kết quả trùng lặp (giữ lại kết quả có điểm cao nhất)
        const uniqueResults = [];
        const seenPaths = new Set();

        results.forEach(result => {
          if (!seenPaths.has(result.path)) {
            uniqueResults.push(result);
            seenPaths.add(result.path);
          }
        });

        // Luôn hiển thị ít nhất một số gợi ý nếu có từ khóa tìm kiếm
        if (uniqueResults.length === 0 && searchTerm.trim().length > 0) {
          // Tìm kiếm mở rộng - hiển thị các chức năng phổ biến làm gợi ý
          roleCategories.forEach(category => {
            if (category && category.items && Array.isArray(category.items)) {
              category.items.slice(0, 2).forEach(item => { // Lấy 2 chức năng đầu tiên từ mỗi danh mục
                if (item && item.title && item.description) {
                  uniqueResults.push({
                    ...item,
                    category: category.title,
                    relevanceScore: 0,
                    isSuggestion: true
                  });
                }
              });
            }
          });
        }

        // Thêm thông tin về việc tìm kiếm có dấu/không dấu
        const finalResults = uniqueResults.map(result => {
          // Kiểm tra xem kết quả này khớp với từ khóa có dấu hay không dấu
          const titleNormalized = removeDiacritics(result.title.toLowerCase());
          const hasAccentMatch = searchTerms.some(term =>
            result.title.toLowerCase().includes(term) ||
            result.description.toLowerCase().includes(term)
          );

          const hasNonAccentMatch = normalizedSearchTerms.some(term =>
            titleNormalized.includes(term) ||
            removeDiacritics(result.description.toLowerCase()).includes(term)
          );

          return {
            ...result,
            matchType: hasAccentMatch
              ? (hasNonAccentMatch ? 'both' : 'accent')
              : (hasNonAccentMatch ? 'non-accent' : 'suggestion')
          };
        });

        setSearchResults(finalResults);

        // Log thông tin tìm kiếm để debug
        console.log('Search terms:', searchTerms);
        console.log('Normalized search terms:', normalizedSearchTerms);
        console.log('Search results:', finalResults);
      } catch (error) {
        console.error('Error searching:', error);
      } finally {
        setIsSearching(false);
      }
    };

    // Debounce search to avoid too many searches while typing
    const timeoutId = setTimeout(() => {
      searchFunctions();
    }, 300);

    return () => clearTimeout(timeoutId);
  }, [searchTerm, user]);

  const getCategoryStructure = (role) => {
    switch (role) {
      case 'EMPLOYEE':
        return [
          {
            id: 'personal-info',
            title: 'Thông Tin Cá Nhân',
            icon: 'fas fa-user',
            items: [
              {
                path: '/profile',
                icon: 'fas fa-user',
                title: 'Thông Tin Cá Nhân',
                description: 'Xem và cập nhật thông tin cá nhân',
              },
              {
                path: '/employee-evaluations',
                icon: 'fas fa-star',
                title: 'Đánh Giá Của Tôi',
                description: 'Xem đánh giá hiệu suất làm việc',
              },
              {
                path: '/performance-management',
                icon: 'fas fa-chart-line',
                title: 'Hiệu Suất Của Tôi',
                description: 'Theo dõi hiệu suất làm việc chi tiết',
              },
            ],
          },
          {
            id: 'vehicle-management',
            title: 'Quản Lý Xe',
            icon: 'fas fa-car',
            items: [
              {
                path: '/request',
                icon: 'fas fa-car-side',
                title: 'Gửi Yêu Cầu Mượn Xe',
                description: 'Tạo yêu cầu mượn xe mới',
              },
              {
                path: '/approval',
                icon: 'fas fa-clipboard-check',
                title: 'Theo Dõi Yêu Cầu',
                description: 'Xem trạng thái yêu cầu',
              },
              {
                path: '/return',
                icon: 'fas fa-undo-alt',
                title: 'Trả Xe',
                description: 'Gửi yêu cầu trả xe',
              }
            ],
          },
          {
            id: 'work-support',
            title: 'Hỗ Trợ & Công Việc',
            icon: 'fas fa-tasks',
            items: [
              {
                path: '/work-journal',
                icon: 'fas fa-file-invoice',
                title: 'Nhật Ký Công Việc',
                description: 'Báo cáo tiến độ công việc',
              },
              {
                path: '/todos',
                icon: 'fas fa-tasks',
                title: 'Sổ Tay Việc Làm',
                description: 'Quản lý công việc cá nhân',
              },
              {
                path: '/leave-requests',
                icon: 'fas fa-calendar-alt',
                title: 'Quản Lý Đơn Nghỉ Phép',
                description: 'Gửi và theo dõi đơn nghỉ phép',
              },
              {
                path: '/personal-schedule',
                icon: 'fas fa-calendar-check',
                title: 'Lịch Làm Việc Cá Nhân',
                description: 'Xem lịch làm việc và ca trực',
              }
            ],
          },
          {
            id: 'support-tools',
            title: 'Hỗ Trợ & Thông Tin',
            icon: 'fas fa-headset',
            items: [
              {
                path: '/support',
                icon: 'fas fa-headset',
                title: 'Gửi Yêu Cầu Hỗ Trợ',
                description: 'Đặt câu hỏi và yêu cầu hỗ trợ',
              },
              {
                path: '/my-support-requests',
                icon: 'fas fa-comments',
                title: 'Yêu Cầu Hỗ Trợ Của Tôi',
                description: 'Xem trạng thái yêu cầu hỗ trợ',
              },
              {
                path: '/guide',
                icon: 'fas fa-book',
                title: 'Hướng Dẫn Sử Dụng',
                description: 'Hướng dẫn sử dụng hệ thống',
              },
              {
                path: '/announcements',
                icon: 'fas fa-bullhorn',
                title: 'Thông Báo & Cập Nhật',
                description: 'Xem thông báo và cập nhật mới nhất',
              },
              {
                path: '/company-documents',
                icon: 'fas fa-file-alt',
                title: 'Tài Liệu Công Ty',
                description: 'Xem tài liệu và hướng dẫn công ty',
              }
            ],
          },
        ];
      case 'REPORT_MANAGER':
        return [
          {
            id: 'personal-info',
            title: 'Thông Tin Cá Nhân',
            icon: 'fas fa-user',
            items: [
              {
                path: '/profile',
                icon: 'fas fa-user',
                title: 'Thông Tin Cá Nhân',
                description: 'Xem và cập nhật thông tin cá nhân',
              },
              {
                path: '/employee-evaluations',
                icon: 'fas fa-star',
                title: 'Đánh Giá Của Tôi',
                description: 'Xem đánh giá hiệu suất làm việc',
              },
              {
                path: '/performance-management',
                icon: 'fas fa-chart-line',
                title: 'Hiệu Suất Của Tôi',
                description: 'Theo dõi hiệu suất làm việc chi tiết',
              },
              {
                path: '/todos',
                icon: 'fas fa-tasks',
                title: 'Sổ Tay Việc Làm',
                description: 'Quản lý công việc cá nhân',
              },
              {
                path: '/leave-requests',
                icon: 'fas fa-calendar-alt',
                title: 'Quản Lý Đơn Nghỉ Phép',
                description: 'Gửi và theo dõi đơn nghỉ phép',
              },
            ],
          },
          {
            id: 'vehicle-management',
            title: 'Quản Lý Xe',
            icon: 'fas fa-car',
            items: [
              {
                path: '/request',
                icon: 'fas fa-car-side',
                title: 'Gửi Yêu Cầu Mượn Xe',
                description: 'Tạo yêu cầu mượn xe mới',
              },
              {
                path: '/approval',
                icon: 'fas fa-clipboard-check',
                title: 'Quản Lý Yêu Cầu',
                description: 'Theo dõi và quản lý yêu cầu mượn xe',
              },
              {
                path: '/vehicle-management',
                icon: 'fas fa-cogs',
                title: 'Quản Lý Thông Tin Xe',
                description: 'Cập nhật thông tin chi tiết xe',
              },
              {
                path: '/return',
                icon: 'fas fa-undo-alt',
                title: 'Trả Xe',
                description: 'Gửi yêu cầu trả xe',
              },
              {
                path: '/report',
                icon: 'fas fa-chart-bar',
                title: 'Báo Cáo & Thống Kê Xe',
                description: 'Xem thống kê và báo cáo',
              }
            ],
          },
          {
            id: 'work-reports',
            title: 'Nhật Ký Công Việc',
            icon: 'fas fa-file-invoice',
            items: [
              {
                path: '/work-journal',
                icon: 'fas fa-file-invoice',
                title: 'Quản Lý Nhật Ký Công Việc',
                description: 'Quản lý báo cáo tiến độ công việc',
              }
            ],
          },
          {
            id: 'recruitment-management-report',
            title: 'Tuyển Dụng Phòng Ban',
            icon: 'fas fa-user-plus',
            items: [
              {
                path: '/recruitment-dashboard',
                icon: 'fas fa-tachometer-alt',
                title: 'Bảng Điều Khiển Tuyển Dụng',
                description: 'Tổng quan tuyển dụng phòng ban',
              },
              {
                path: '/recruitment-requests',
                icon: 'fas fa-file-alt',
                title: 'Yêu Cầu Tuyển Dụng',
                description: 'Quản lý yêu cầu tuyển dụng phòng ban',
              },

              {
                path: '/interviews',
                icon: 'fas fa-calendar-alt',
                title: 'Phỏng Vấn Phòng Ban',
                description: 'Quản lý phỏng vấn cho phòng ban',
              },
            ],
          },
          {
            id: 'support-tools',
            title: 'Hỗ Trợ & Công Cụ',
            icon: 'fas fa-tools',
            items: [
              {
                path: '/support',
                icon: 'fas fa-headset',
                title: 'Gửi Yêu Cầu Hỗ Trợ',
                description: 'Đặt câu hỏi và yêu cầu hỗ trợ',
              },
              {
                path: '/my-support-requests',
                icon: 'fas fa-comments',
                title: 'Yêu Cầu Hỗ Trợ Của Tôi',
                description: 'Xem trạng thái yêu cầu hỗ trợ',
              },
              {
                path: '/guide',
                icon: 'fas fa-book',
                title: 'Hướng Dẫn Sử Dụng',
                description: 'Hướng dẫn sử dụng hệ thống',
              },
              {
                path: '/announcements',
                icon: 'fas fa-bullhorn',
                title: 'Thông Báo & Cập Nhật',
                description: 'Xem thông báo và cập nhật mới nhất',
              },
              {
                path: '/company-documents',
                icon: 'fas fa-file-alt',
                title: 'Tài Liệu Công Ty',
                description: 'Xem tài liệu và hướng dẫn công ty',
              }
            ],
          }
        ];
      case 'LEVEL_I_MANAGER':
        return [
          {
            id: 'dashboard-overview',
            title: 'Tổng Quan & Cá Nhân',
            icon: 'fas fa-tachometer-alt',
            items: [
              {
                path: '/profile',
                icon: 'fas fa-user',
                title: 'Thông Tin Cá Nhân',
                description: 'Xem và cập nhật thông tin cá nhân',
              },
              {
                path: '/todos',
                icon: 'fas fa-tasks',
                title: 'Sổ Tay Việc Làm',
                description: 'Quản lý công việc cá nhân',
              },
              {
                path: '/leave-requests',
                icon: 'fas fa-calendar-alt',
                title: 'Quản Lý Đơn Nghỉ Phép',
                description: 'Gửi và theo dõi đơn nghỉ phép',
              },
              {
                path: '/employee-evaluations',
                icon: 'fas fa-star',
                title: 'Đánh Giá Nhân Viên',
                description: 'Quản lý đánh giá hiệu suất nhân viên',
              },
              {
                path: '/performance-management',
                icon: 'fas fa-chart-line',
                title: 'Quản Lý Hiệu Suất',
                description: 'Hệ thống đánh giá hiệu suất toàn diện',
              },
            ],
          },
          {
            id: 'vehicle-management',
            title: 'Quản Lý Xe & Vận Hành',
            icon: 'fas fa-car',
            items: [
              {
                path: '/request',
                icon: 'fas fa-car-side',
                title: 'Gửi Yêu Cầu Mượn Xe',
                description: 'Tạo yêu cầu mượn xe mới',
              },
              {
                path: '/approval',
                icon: 'fas fa-clipboard-check',
                title: 'Phê Duyệt Yêu Cầu',
                description: 'Phê duyệt và quản lý yêu cầu mượn xe',
              },
              {
                path: '/vehicle-management',
                icon: 'fas fa-cogs',
                title: 'Quản Lý Thông Tin Xe',
                description: 'Cập nhật thông tin chi tiết xe',
              },
              {
                path: '/fuel-management',
                icon: 'fas fa-gas-pump',
                title: 'Quản Lý Nhiên Liệu',
                description: 'Theo dõi và quản lý nhiên liệu xe',
              },
              {
                path: '/return',
                icon: 'fas fa-undo-alt',
                title: 'Trả Xe',
                description: 'Gửi yêu cầu trả xe',
              },
              {
                path: '/return-reports',
                icon: 'fas fa-clipboard-list',
                title: 'Báo Cáo Trả Xe',
                description: 'Xem và quản lý báo cáo trả xe',
              },
            ],
          },
          {
            id: 'reports-analytics',
            title: 'Báo Cáo & Thống Kê',
            icon: 'fas fa-chart-line',
            items: [
              {
                path: '/report',
                icon: 'fas fa-chart-bar',
                title: 'Báo Cáo & Thống Kê Xe',
                description: 'Xem thống kê và báo cáo chi tiết',
              },
              {
                path: '/work-journal',
                icon: 'fas fa-file-invoice',
                title: 'Quản Lý Nhật Ký Công Việc',
                description: 'Quản lý báo cáo tiến độ công việc',
              },
            ],
          },
          {
            id: 'recruitment-management-level1',
            title: 'Tuyển Dụng Nhân Sự',
            icon: 'fas fa-user-plus',
            items: [
              {
                path: '/recruitment-dashboard',
                icon: 'fas fa-tachometer-alt',
                title: 'Bảng Điều Khiển Tuyển Dụng',
                description: 'Tổng quan về hoạt động tuyển dụng',
              },
              {
                path: '/recruitment-requests',
                icon: 'fas fa-file-alt',
                title: 'Yêu Cầu Tuyển Dụng',
                description: 'Tạo và quản lý yêu cầu tuyển dụng',
              },

              {
                path: '/interviews',
                icon: 'fas fa-calendar-alt',
                title: 'Quản Lý Phỏng Vấn',
                description: 'Lên lịch và quản lý phỏng vấn',
              },
            ],
          },
          {
            id: 'support-communication',
            title: 'Hỗ Trợ & Thông Tin',
            icon: 'fas fa-headset',
            items: [
              {
                path: '/support',
                icon: 'fas fa-headset',
                title: 'Gửi Yêu Cầu Hỗ Trợ',
                description: 'Đặt câu hỏi và yêu cầu hỗ trợ',
              },
              {
                path: '/my-support-requests',
                icon: 'fas fa-comments',
                title: 'Yêu Cầu Hỗ Trợ Của Tôi',
                description: 'Xem trạng thái yêu cầu hỗ trợ',
              },
              {
                path: '/guide',
                icon: 'fas fa-book',
                title: 'Hướng Dẫn Sử Dụng',
                description: 'Hướng dẫn sử dụng hệ thống',
              },
              {
                path: '/announcements',
                icon: 'fas fa-bullhorn',
                title: 'Thông Báo & Cập Nhật',
                description: 'Xem thông báo và cập nhật mới nhất',
              },
              {
                path: '/company-documents',
                icon: 'fas fa-file-alt',
                title: 'Tài Liệu Công Ty',
                description: 'Xem tài liệu và hướng dẫn công ty',
              },
            ],
          },
        ];
      case 'LEVEL_II_MANAGER':
        return [
          {
            id: 'executive-dashboard',
            title: 'Bảng Điều Khiển Điều Hành',
            icon: 'fas fa-tachometer-alt',
            items: [
              {
                path: '/profile',
                icon: 'fas fa-user',
                title: 'Thông Tin Cá Nhân',
                description: 'Xem và cập nhật thông tin cá nhân',
              },
              {
                path: '/todos',
                icon: 'fas fa-tasks',
                title: 'Sổ Tay Việc Làm',
                description: 'Quản lý công việc cá nhân',
              },
              {
                path: '/leave-requests',
                icon: 'fas fa-calendar-alt',
                title: 'Quản Lý Đơn Nghỉ Phép',
                description: 'Gửi và theo dõi đơn nghỉ phép',
              },
            ],
          },
          {
            id: 'vehicle-fleet-management',
            title: 'Quản Lý Đội Xe',
            icon: 'fas fa-car',
            items: [
              {
                path: '/request',
                icon: 'fas fa-car-side',
                title: 'Gửi Yêu Cầu Mượn Xe',
                description: 'Tạo yêu cầu mượn xe mới',
              },
              {
                path: '/approval',
                icon: 'fas fa-clipboard-check',
                title: 'Phê Duyệt Yêu Cầu',
                description: 'Phê duyệt và quản lý yêu cầu mượn xe',
              },
              {
                path: '/vehicle-management',
                icon: 'fas fa-cogs',
                title: 'Quản Lý Thông Tin Xe',
                description: 'Cập nhật thông tin chi tiết xe',
              },
              {
                path: '/fuel-management',
                icon: 'fas fa-gas-pump',
                title: 'Quản Lý Nhiên Liệu',
                description: 'Theo dõi và quản lý nhiên liệu xe',
              },
              {
                path: '/return',
                icon: 'fas fa-undo-alt',
                title: 'Trả Xe',
                description: 'Gửi yêu cầu trả xe',
              },
              {
                path: '/return-reports',
                icon: 'fas fa-clipboard-list',
                title: 'Báo Cáo Trả Xe',
                description: 'Xem và quản lý báo cáo trả xe',
              },
            ],
          },
          {
            id: 'human-resources-management',
            title: 'Quản Lý Nhân Sự',
            icon: 'fas fa-users',
            items: [
              {
                path: '/human-resources',
                icon: 'fas fa-user-tie',
                title: 'Quản Lý Nhân Sự Công Ty',
                description: 'Quản lý toàn bộ nhân sự công ty',
              },
              {
                path: '/driver-profiles',
                icon: 'fas fa-id-card',
                title: 'Hồ Sơ Tài Xế',
                description: 'Quản lý hồ sơ tài xế',
              },
              {
                path: '/admin/driver-management',
                icon: 'fas fa-users-cog',
                title: 'Quản Lý Hồ Sơ Tài Xế Nâng Cao',
                description: 'Xem, sửa, xóa và xác thực hồ sơ tài xế toàn hệ thống',
              },
              {
                path: '/attendance-management',
                icon: 'fas fa-clock',
                title: 'Quản Lý Chấm Công',
                description: 'Quản lý chấm công',
              },
              {
                path: '/employee-evaluations',
                icon: 'fas fa-star',
                title: 'Đánh Giá Nhân Viên',
                description: 'Quản lý đánh giá hiệu suất nhân viên',
              },
              {
                path: '/performance-management',
                icon: 'fas fa-chart-line',
                title: 'Quản Lý Hiệu Suất',
                description: 'Hệ thống đánh giá hiệu suất toàn diện',
              },
            ],
          },
          {
            id: 'recruitment-management',
            title: 'Tuyển Dụng Nhân Sự',
            icon: 'fas fa-user-plus',
            items: [
              {
                path: '/recruitment-dashboard',
                icon: 'fas fa-tachometer-alt',
                title: 'Bảng Điều Khiển Tuyển Dụng',
                description: 'Tổng quan về hoạt động tuyển dụng',
              },
              {
                path: '/recruitment-requests',
                icon: 'fas fa-file-alt',
                title: 'Yêu Cầu Tuyển Dụng',
                description: 'Quản lý yêu cầu tuyển dụng nhân sự',
              },

              {
                path: '/interviews',
                icon: 'fas fa-calendar-alt',
                title: 'Quản Lý Phỏng Vấn',
                description: 'Lên lịch và quản lý phỏng vấn',
              },
            ],
          },
          {
            id: 'administrative-operations',
            title: 'Quản Lý Hành Chính',
            icon: 'fas fa-building',
            items: [
              {
                path: '/reception',
                icon: 'fas fa-door-open',
                title: 'Quản Lý Thăm Gặp & Làm Việc',
                description: 'Quản lý hoạt động thăm gặp và làm việc tại tòa nhà',
              },
              {
                path: '/admin-work-management',
                icon: 'fas fa-briefcase',
                title: 'Phạm vi công việc',
                description: 'Quản lý toàn bộ công việc hành chính',
              },
              {
                path: '/asset-management',
                icon: 'fas fa-boxes',
                title: 'Quản Lý Tài Sản',
                description: 'Quản lý tài sản công ty',
              },
              {
                path: '/pickup-schedules',
                icon: 'fas fa-calendar-check',
                title: 'Lịch Đón Khách',
                description: 'Quản lý lịch đón khách và thông báo tài xế',
              },
            ],
          },
          {
            id: 'reports-analytics-advanced',
            title: 'Báo Cáo & Phân Tích',
            icon: 'fas fa-chart-line',
            items: [
              {
                path: '/report',
                icon: 'fas fa-chart-bar',
                title: 'Báo Cáo & Thống Kê Xe',
                description: 'Xem thống kê và báo cáo chi tiết',
              },
              {
                path: '/work-journal',
                icon: 'fas fa-file-invoice',
                title: 'Quản Lý Nhật Ký Công Việc',
                description: 'Quản lý toàn bộ Nhật Ký Công Việc',
              },
            ],
          },
          {
            id: 'support-communication-mgr',
            title: 'Hỗ Trợ & Thông Tin',
            icon: 'fas fa-headset',
            items: [
              {
                path: '/support',
                icon: 'fas fa-headset',
                title: 'Gửi Yêu Cầu Hỗ Trợ',
                description: 'Đặt câu hỏi và yêu cầu hỗ trợ',
              },
              {
                path: '/my-support-requests',
                icon: 'fas fa-comments',
                title: 'Yêu Cầu Hỗ Trợ Của Tôi',
                description: 'Xem trạng thái yêu cầu hỗ trợ',
              },
              {
                path: '/guide',
                icon: 'fas fa-book',
                title: 'Hướng Dẫn Sử Dụng',
                description: 'Hướng dẫn sử dụng hệ thống',
              },
              {
                path: '/announcements',
                icon: 'fas fa-bullhorn',
                title: 'Thông Báo & Cập Nhật',
                description: 'Xem thông báo và cập nhật mới nhất',
              },
              {
                path: '/company-documents',
                icon: 'fas fa-file-alt',
                title: 'Tài Liệu Công Ty',
                description: 'Xem tài liệu và hướng dẫn công ty',
              },
              {
                path: '/support-admin',
                icon: 'fas fa-user-cog',
                title: 'Quản Lý Hỗ Trợ',
                description: 'Quản lý yêu cầu hỗ trợ của người dùng',
              },
            ],
          },
        ];
      case 'ACCOUNTANT':
        return [
          {
            id: 'profile-section',
            title: 'Thông Tin Cá Nhân',
            icon: 'fas fa-user',
            items: [
              {
                path: '/profile',
                icon: 'fas fa-user',
                title: 'Thông Tin Cá Nhân',
                description: 'Cập nhật thông tin cá nhân',
              },
              {
                path: '/todos',
                icon: 'fas fa-tasks',
                title: 'Sổ Tay Việc Làm',
                description: 'Quản lý công việc cá nhân',
              },
              {
                path: '/leave-requests',
                icon: 'fas fa-calendar-alt',
                title: 'Quản Lý Đơn Nghỉ Phép',
                description: 'Gửi và theo dõi đơn nghỉ phép',
              },
            ],
          },
          {
            id: 'asset-ops',
            title: 'Quản Lý Tài Sản & Xe',
            icon: 'fas fa-car',
            items: [
              {
                path: '/approval',
                icon: 'fas fa-file-invoice',
                title: 'Quản Lý Yêu Cầu',
                description: 'Duyệt yêu cầu mượn xe',
              },
              {
                path: '/vehicle-management',
                icon: 'fas fa-cogs',
                title: 'Quản Lý Thông Tin Xe',
                description: 'Cập nhật thông tin chi tiết xe',
              },
              {
                path: '/asset-management',
                icon: 'fas fa-boxes',
                title: 'Quản Lý Tài Sản',
                description: 'Quản lý tài sản công ty',
              },
              {
                path: '/return-reports',
                icon: 'fas fa-clipboard-list',
                title: 'Quản Lý Báo Cáo Trả Xe',
                description: 'Xem và quản lý báo cáo trả xe',
              },
              {
                path: '/fuel-management',
                icon: 'fas fa-gas-pump',
                title: 'Quản Lý Nhiên Liệu',
                description: 'Theo dõi và quản lý nhiên liệu xe',
              },
              {
                path: '/report',
                icon: 'fas fa-chart-bar',
                title: 'Báo Cáo & Thống Kê Xe',
                description: 'Xem thống kê và báo cáo',
              },
            ],
          },
          {
            id: 'support-reports',
            title: 'Báo Cáo & Hỗ Trợ',
            icon: 'fas fa-file-invoice',
            items: [
              {
                path: '/work-journal',
                icon: 'fas fa-file-invoice',
                title: 'Quản Lý Nhật Ký Công Việc',
                description: 'Quản lý toàn bộ Nhật Ký Công Việc',
              },
              {
                path: '/support',
                icon: 'fas fa-headset',
                title: 'Gửi Yêu Cầu Hỗ Trợ',
                description: 'Đặt câu hỏi và yêu cầu hỗ trợ',
              },
              {
                path: '/my-support-requests',
                icon: 'fas fa-comments',
                title: 'Yêu Cầu Hỗ Trợ Của Tôi',
                description: 'Xem trạng thái yêu cầu hỗ trợ',
              },
              {
                path: '/guide',
                icon: 'fas fa-book',
                title: 'Hướng Dẫn Sử Dụng',
                description: 'Hướng dẫn sử dụng hệ thống',
              },
              {
                path: '/announcements',
                icon: 'fas fa-bullhorn',
                title: 'Thông Báo & Cập Nhật',
                description: 'Xem thông báo và cập nhật mới nhất',
              },
              {
                path: '/company-documents',
                icon: 'fas fa-file-alt',
                title: 'Tài Liệu Công Ty',
                description: 'Xem tài liệu và hướng dẫn công ty',
              },
            ],
          },
        ];
      case 'ADMIN':
        return [
          {
            id: 'admin-dashboard',
            title: 'Bảng Điều Khiển Quản Trị',
            icon: 'fas fa-tachometer-alt',
            items: [
              {
                path: '/profile',
                icon: 'fas fa-user',
                title: 'Thông Tin Cá Nhân',
                description: 'Xem và cập nhật thông tin cá nhân',
              },
              {
                path: '/todos',
                icon: 'fas fa-tasks',
                title: 'Sổ Tay Việc Làm',
                description: 'Quản lý công việc cá nhân',
              },
              {
                path: '/leave-requests',
                icon: 'fas fa-calendar-alt',
                title: 'Quản Lý Đơn Nghỉ Phép',
                description: 'Gửi và theo dõi đơn nghỉ phép',
              },
              {
                path: '/employee-evaluations',
                icon: 'fas fa-star',
                title: 'Đánh Giá Nhân Viên',
                description: 'Quản lý đánh giá hiệu suất nhân viên',
              },
              {
                path: '/performance-management',
                icon: 'fas fa-chart-line',
                title: 'Quản Lý Hiệu Suất',
                description: 'Hệ thống đánh giá hiệu suất toàn diện',
              },
            ],
          },
          {
            id: 'vehicle-fleet-operations',
            title: 'Vận Hành Đội Xe',
            icon: 'fas fa-car',
            items: [
              {
                path: '/request',
                icon: 'fas fa-car-side',
                title: 'Gửi Yêu Cầu Mượn Xe',
                description: 'Tạo yêu cầu mượn xe mới',
              },
              {
                path: '/approval',
                icon: 'fas fa-clipboard-check',
                title: 'Phê Duyệt Yêu Cầu',
                description: 'Phê duyệt và quản lý yêu cầu mượn xe',
              },
              {
                path: '/vehicle-management',
                icon: 'fas fa-cogs',
                title: 'Quản Lý Thông Tin Xe',
                description: 'Cập nhật thông tin chi tiết xe',
              },
              {
                path: '/fuel-management',
                icon: 'fas fa-gas-pump',
                title: 'Quản Lý Nhiên Liệu',
                description: 'Theo dõi và quản lý nhiên liệu xe',
              },
              {
                path: '/return',
                icon: 'fas fa-undo-alt',
                title: 'Trả Xe',
                description: 'Gửi yêu cầu trả xe',
              },
              {
                path: '/return-reports',
                icon: 'fas fa-clipboard-list',
                title: 'Báo Cáo Trả Xe',
                description: 'Xem và quản lý báo cáo trả xe',
              },
            ],
          },
          {
            id: 'human-resources-admin',
            title: 'Quản Lý Nhân Sự',
            icon: 'fas fa-users',
            items: [
              {
                path: '/human-resources',
                icon: 'fas fa-user-tie',
                title: 'Quản Lý Nhân Sự Công Ty',
                description: 'Quản lý thông tin nhân sự công ty',
              },
              {
                path: '/driver-profiles',
                icon: 'fas fa-id-card',
                title: 'Hồ Sơ Tài Xế',
                description: 'Quản lý hồ sơ tài xế',
              },
              {
                path: '/admin/driver-management',
                icon: 'fas fa-users-cog',
                title: 'Quản Lý Hồ Sơ Tài Xế Nâng Cao',
                description: 'Xem, sửa, xóa và xác thực hồ sơ tài xế toàn hệ thống',
              },
              {
                path: '/attendance-management',
                icon: 'fas fa-clock',
                title: 'Quản Lý Chấm Công',
                description: 'Quản lý chấm công',
              },
              {
                path: '/work-journal',
                icon: 'fas fa-file-invoice',
                title: 'Quản Lý Nhật Ký Công Việc',
                description: 'Quản lý toàn bộ Nhật Ký Công Việc',
              },
              {
                path: '/leave-requests',
                icon: 'fas fa-calendar-alt',
                title: 'Quản Lý Nghỉ Phép',
                description: 'Quản lý đơn nghỉ phép của nhân viên',
              },
            ],
          },
          {
            id: 'recruitment-management-admin',
            title: 'Tuyển Dụng Nhân Sự',
            icon: 'fas fa-user-plus',
            items: [
              {
                path: '/recruitment-dashboard',
                icon: 'fas fa-tachometer-alt',
                title: 'Bảng Điều Khiển Tuyển Dụng',
                description: 'Tổng quan về hoạt động tuyển dụng',
              },
              {
                path: '/recruitment-requests',
                icon: 'fas fa-file-alt',
                title: 'Yêu Cầu Tuyển Dụng',
                description: 'Quản lý yêu cầu tuyển dụng nhân sự',
              },

              {
                path: '/interviews',
                icon: 'fas fa-calendar-alt',
                title: 'Quản Lý Phỏng Vấn',
                description: 'Lên lịch và quản lý phỏng vấn',
              },
            ],
          },
          {
            id: 'asset-facility-management',
            title: 'Quản Lý Tài Sản & Cơ Sở',
            icon: 'fas fa-building',
            items: [
              {
                path: '/asset-management',
                icon: 'fas fa-boxes',
                title: 'Quản Lý Tài Sản',
                description: 'Quản lý tài sản công ty',
              },
              {
                path: '/reception',
                icon: 'fas fa-door-open',
                title: 'Quản Lý Thăm Gặp & Làm Việc',
                description: 'Quản lý hoạt động tại tòa nhà',
              },
              {
                path: '/admin-work-management',
                icon: 'fas fa-briefcase',
                title: 'Phạm vi công việc',
                description: 'Quản lý toàn bộ công việc hành chính',
              },
            ],
          },
          {
            id: 'reports-analytics-admin',
            title: 'Báo Cáo & Phân Tích',
            icon: 'fas fa-chart-line',
            items: [
              {
                path: '/report',
                icon: 'fas fa-chart-bar',
                title: 'Báo Cáo & Thống Kê Xe',
                description: 'Thống kê và phân tích hoạt động doanh nghiệp',
              },
              {
                path: '/work-journal',
                icon: 'fas fa-file-invoice',
                title: 'Quản Lý Nhật Ký Công Việc',
                description: 'Quản lý toàn bộ Nhật Ký Công Việc',
              },
            ],
          },
          {
            id: 'communication-support-admin',
            title: 'Thông Tin & Hỗ Trợ',
            icon: 'fas fa-headset',
            items: [
              {
                path: '/announcements',
                icon: 'fas fa-bullhorn',
                title: 'Thông Báo & Cập Nhật',
                description: 'Xem thông báo và cập nhật mới nhất',
              },
              {
                path: '/support',
                icon: 'fas fa-headset',
                title: 'Gửi Yêu Cầu Hỗ Trợ',
                description: 'Đặt câu hỏi và yêu cầu hỗ trợ',
              },
              {
                path: '/my-support-requests',
                icon: 'fas fa-comments',
                title: 'Yêu Cầu Hỗ Trợ Của Tôi',
                description: 'Xem trạng thái yêu cầu hỗ trợ',
              },
              {
                path: '/support-admin',
                icon: 'fas fa-user-cog',
                title: 'Quản Lý Hỗ Trợ',
                description: 'Quản lý yêu cầu hỗ trợ của người dùng',
              },
              {
                path: '/guide',
                icon: 'fas fa-book',
                title: 'Hướng Dẫn Sử Dụng',
                description: 'Hướng dẫn sử dụng hệ thống',
              },
              {
                path: '/company-documents',
                icon: 'fas fa-file-alt',
                title: 'Tài Liệu Công Ty',
                description: 'Xem tài liệu và hướng dẫn công ty',
              },
            ],
          },
        ];
      case 'SUPER_ADMIN':
        return [
          {
            id: 'super-admin-dashboard',
            title: 'Bảng Điều Khiển Tổng Quản Trị',
            icon: 'fas fa-crown',
            items: [
              {
                path: '/profile',
                icon: 'fas fa-user',
                title: 'Thông Tin Cá Nhân',
                description: 'Cập nhật thông tin cá nhân',
              },
              {
                path: '/todos',
                icon: 'fas fa-tasks',
                title: 'Sổ Tay Việc Làm',
                description: 'Quản lý công việc cá nhân',
              },
              {
                path: '/leave-requests',
                icon: 'fas fa-calendar-alt',
                title: 'Quản Lý Đơn Nghỉ Phép',
                description: 'Gửi và theo dõi đơn nghỉ phép',
              },
            ],
          },
          {
            id: 'system-administration',
            title: 'Quản Trị Hệ Thống',
            icon: 'fas fa-cogs',
            items: [
              {
                path: '/superadmin',
                icon: 'fas fa-user-shield',
                title: 'Quản Lý Tài Khoản Nhân Viên',
                description: 'Quản lý toàn bộ tài khoản nhân viên',
              },
              {
                path: '/activity-logs',
                icon: 'fas fa-history',
                title: 'Nhật Ký Hoạt Động',
                description: 'Xem lịch sử hoạt động của hệ thống',
              },
              {
                path: '/admin/announcements',
                icon: 'fas fa-bell',
                title: 'Quản Lý Thông Báo',
                description: 'Tạo và quản lý thông báo hệ thống',
              },
              {
                path: '/admin-notifications',
                icon: 'fas fa-bell',
                title: 'Quản Lý Thông Báo Cũ',
                description: 'Quản lý thông báo và nhắc nhở',
              },
              {
                path: '/link-management',
                icon: 'fas fa-link',
                title: 'Quản Lý Liên Kết',
                description: 'Quản lý liên kết hệ thống',
              },
              {
                path: '/page-visibility',
                icon: 'fas fa-eye',
                title: 'Quản Lý Hiển Thị Trang',
                description: 'Cấu hình hiển thị các trang trong hệ thống',
              },
              {
                path: '/system-status',
                icon: 'fas fa-server',
                title: 'Quản Lý Trạng Thái Hệ Thống',
                description: 'Cấu hình trạng thái hoạt động của hệ thống',
              },
              {
                path: '/online-users',
                icon: 'fas fa-users',
                title: 'Theo Dõi Người Dùng Trực Tuyến',
                description: 'Xem danh sách người dùng đang hoạt động',
              },
              {
                path: '/software-rating-management',
                icon: 'fas fa-star',
                title: 'Quản Lý Đánh Giá Phần Mềm',
                description: 'Xem và quản lý đánh giá từ nhân viên',
              },
            ],
          },
          {
            id: 'fleet-asset-management',
            title: 'Quản Lý Đội Xe & Tài Sản',
            icon: 'fas fa-car',
            items: [
              {
                path: '/request',
                icon: 'fas fa-car-side',
                title: 'Gửi Yêu Cầu Mượn Xe',
                description: 'Tạo yêu cầu mượn xe mới',
              },
              {
                path: '/approval',
                icon: 'fas fa-clipboard-check',
                title: 'Phê Duyệt Yêu Cầu',
                description: 'Phê duyệt và quản lý yêu cầu mượn xe',
              },
              {
                path: '/vehicle-management',
                icon: 'fas fa-cogs',
                title: 'Quản Lý Thông Tin Xe',
                description: 'Cập nhật thông tin chi tiết xe',
              },
              {
                path: '/fuel-management',
                icon: 'fas fa-gas-pump',
                title: 'Quản Lý Nhiên Liệu',
                description: 'Theo dõi và quản lý nhiên liệu xe',
              },
              {
                path: '/return',
                icon: 'fas fa-undo-alt',
                title: 'Trả Xe',
                description: 'Gửi yêu cầu trả xe',
              },
              {
                path: '/return-reports',
                icon: 'fas fa-clipboard-list',
                title: 'Báo Cáo Trả Xe',
                description: 'Xem và quản lý báo cáo trả xe',
              },
              {
                path: '/asset-management',
                icon: 'fas fa-boxes',
                title: 'Quản Lý Tài Sản',
                description: 'Quản lý tài sản công ty',
              },
            ],
          },
          {
            id: 'human-resources-super',
            title: 'Quản Lý Nhân Sự Toàn Diện',
            icon: 'fas fa-users',
            items: [
              {
                path: '/human-resources',
                icon: 'fas fa-user-tie',
                title: 'Quản Lý Nhân Sự Công Ty',
                description: 'Quản lý thông tin nhân sự',
              },
              {
                path: '/driver-profiles',
                icon: 'fas fa-id-card',
                title: 'Hồ Sơ Tài Xế',
                description: 'Quản lý hồ sơ tài xế',
              },
              {
                path: '/admin/driver-management',
                icon: 'fas fa-users-cog',
                title: 'Quản Lý Hồ Sơ Tài Xế Nâng Cao',
                description: 'Xem, sửa, xóa và xác thực hồ sơ tài xế toàn hệ thống',
              },
              {
                path: '/employee-evaluations',
                icon: 'fas fa-star',
                title: 'Đánh Giá Nhân Viên',
                description: 'Quản lý đánh giá hiệu suất nhân viên',
              },
              {
                path: '/performance-management',
                icon: 'fas fa-chart-line',
                title: 'Quản Lý Hiệu Suất',
                description: 'Hệ thống đánh giá hiệu suất toàn diện',
              },
            ],
          },
          {
            id: 'recruitment-management-super',
            title: 'Tuyển Dụng Nhân Sự',
            icon: 'fas fa-user-plus',
            items: [
              {
                path: '/recruitment-dashboard',
                icon: 'fas fa-tachometer-alt',
                title: 'Bảng Điều Khiển Tuyển Dụng',
                description: 'Tổng quan về hoạt động tuyển dụng',
              },
              {
                path: '/recruitment-requests',
                icon: 'fas fa-file-alt',
                title: 'Yêu Cầu Tuyển Dụng',
                description: 'Quản lý yêu cầu tuyển dụng nhân sự',
              },

              {
                path: '/interviews',
                icon: 'fas fa-calendar-alt',
                title: 'Quản Lý Phỏng Vấn',
                description: 'Lên lịch và quản lý phỏng vấn',
              },
            ],
          },
          {
            id: 'facility-operations',
            title: 'Quản Lý Cơ Sở & Hoạt Động',
            icon: 'fas fa-building',
            items: [
              {
                path: '/reception',
                icon: 'fas fa-door-open',
                title: 'Quản Lý Thăm Gặp & Làm Việc',
                description: 'Quản lý hoạt động thăm gặp và làm việc tại tòa nhà',
              },
              {
                path: '/admin-work-management',
                icon: 'fas fa-briefcase',
                title: 'Phạm vi công việc',
                description: 'Quản lý toàn bộ công việc hành chính',
              },
            ],
          },
          {
            id: 'analytics-reporting',
            title: 'Báo Cáo & Phân Tích Dữ Liệu',
            icon: 'fas fa-chart-line',
            items: [
              {
                path: '/report',
                icon: 'fas fa-chart-bar',
                title: 'Báo Cáo & Thống Kê Xe',
                description: 'Thống kê và phân tích toàn diện',
              },
              {
                path: '/work-journal',
                icon: 'fas fa-file-invoice',
                title: 'Quản Lý Nhật Ký Công Việc',
                description: 'Quản lý toàn bộ Nhật Ký Công Việc',
              },
            ],
          },
          {
            id: 'support-communication-super',
            title: 'Hỗ Trợ & Thông Tin',
            icon: 'fas fa-headset',
            items: [
              {
                path: '/announcements',
                icon: 'fas fa-bullhorn',
                title: 'Xem Thông Báo',
                description: 'Xem thông báo và cập nhật mới nhất',
              },
              {
                path: '/support',
                icon: 'fas fa-headset',
                title: 'Gửi Yêu Cầu Hỗ Trợ',
                description: 'Đặt câu hỏi và yêu cầu hỗ trợ',
              },
              {
                path: '/my-support-requests',
                icon: 'fas fa-comments',
                title: 'Yêu Cầu Hỗ Trợ Của Tôi',
                description: 'Xem trạng thái yêu cầu hỗ trợ',
              },
              {
                path: '/support-admin',
                icon: 'fas fa-user-cog',
                title: 'Quản Lý Hỗ Trợ',
                description: 'Quản lý yêu cầu hỗ trợ của người dùng',
              },
              {
                path: '/guide',
                icon: 'fas fa-book',
                title: 'Hướng Dẫn Sử Dụng',
                description: 'Hướng dẫn sử dụng hệ thống',
              },
              {
                path: '/company-documents',
                icon: 'fas fa-file-alt',
                title: 'Tài Liệu Công Ty',
                description: 'Xem tài liệu và hướng dẫn công ty',
              },
            ],
          },
        ];
      default:
        return [];
    }
  };

  const categories = buildCategoriesFromNavigation(user?.role || 'EMPLOYEE');
  const SHOW_CATEGORIES_UI = false;

  // Define common items for admin-like roles to avoid repetition
  const commonAdminQuickAccess = [
    { path: '/executive-dashboard', title: 'Tổng Quan Doanh Nghiệp', icon: 'fas fa-chart-line' },
    { path: '/request', title: 'Gửi Yêu Cầu Mượn Xe', icon: 'fas fa-car-side' },
    { path: '/work-journal', title: 'Nhật Ký Công Việc', icon: 'fas fa-file-invoice' },
    { path: '/report', title: 'Báo Cáo & Thống Kê Xe', icon: 'fas fa-chart-bar' },
    { path: '/leave-requests', title: 'Quản Lý Đơn Nghỉ Phép', icon: 'fas fa-calendar-alt' },
    { path: '/human-resources', title: 'Quản Lý Nhân Sự Công Ty', icon: 'fas fa-user-shield' },
  ];

  const getQuickAccessItems = (currentUser, userFavorites) => {
    if (!currentUser) return [];

    // If user has favorites, use them (max 12, min 1)
    if (userFavorites && userFavorites.length > 0) {
      return userFavorites.slice(0, 12); // Ensure max 12 items
    }

    // Default quick access items based on role if no favorites
    const role = currentUser.role;
    const defaultItems = [];

    if (['ADMIN', 'SUPER_ADMIN', 'LEVEL_II_MANAGER', 'LEVEL_I_MANAGER'].includes(role)) {
      defaultItems.push(...commonAdminQuickAccess.slice(0, 6));
    } else if (['EMPLOYEE', 'REPORT_MANAGER'].includes(role)) {
      defaultItems.push(
        { path: '/request', title: 'Gửi Yêu Cầu Mượn Xe', icon: 'fas fa-car-side' },
        { path: '/driver-profiles', title: 'Hồ Sơ Tài Xế', icon: 'fas fa-id-card' },
        { path: '/work-journal', title: 'Nhật Ký Công Việc', icon: 'fas fa-file-invoice' },
        { path: '/leave-requests', title: 'Quản Lý Đơn Nghỉ Phép', icon: 'fas fa-calendar-alt' },
        { path: '/announcements', title: 'Thông Báo & Cập Nhật', icon: 'fas fa-bullhorn' },
        { path: '/todos', title: 'Sổ Tay Việc Làm', icon: 'fas fa-tasks' },
        { path: '/pdf-management', title: 'Quản Lý PDF', icon: 'fas fa-file-pdf' },
      );
    } else if (role === 'ACCOUNTANT') {
      defaultItems.push(
        { path: '/approval', title: 'Quản Lý Yêu Cầu', icon: 'fas fa-file-invoice' },
        { path: '/vehicle-management', title: 'Quản Lý Thông Tin Xe', icon: 'fas fa-cogs' },
        { path: '/asset-management', title: 'Quản Lý Tài Sản', icon: 'fas fa-boxes' },
        { path: '/fuel-management', title: 'Quản Lý Nhiên Liệu', icon: 'fas fa-gas-pump' },
        { path: '/work-journal', title: 'Quản Lý Nhật Ký Công Việc', icon: 'fas fa-file-invoice' },
        { path: '/todos', title: 'Sổ Tay Việc Làm', icon: 'fas fa-tasks' }
      );
    }

    // Ensure at least 1 item
    return defaultItems.length > 0 ? defaultItems.slice(0, 12) : [
      { path: '/request', title: 'Gửi Yêu Cầu Mượn Xe', icon: 'fas fa-car-side' }
    ];
  };

  const quickAccessItems = getQuickAccessItems(user, favorites);

  const handleCategoryClick = (category) => {
    // Chuyển đến tab "Tất cả danh mục" và hiển thị danh mục được chọn
    setActiveTab('categories');
    setSelectedCategory(category);

    // Scroll đến danh mục đó (sử dụng setTimeout để đảm bảo DOM đã được cập nhật)
    setTimeout(() => {
      const categoryElement = document.getElementById(`category-${category.id}`);
      if (categoryElement) {
        categoryElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }, 100);
  };

  const formatTime = () => {
    const now = new Date();
    const hours = now.getHours();
    let greeting;
    if (hours >= 5 && hours < 12) {
      greeting = 'Chào buổi sáng';
    } else if (hours >= 12 && hours < 18) {
      greeting = 'Chào buổi chiều';
    } else {
      greeting = 'Chào buổi tối';
    }
    return {
      greeting,
      date: now.toLocaleDateString('vi-VN', {
        weekday: 'long',
        day: 'numeric',
        month: 'long',
        year: 'numeric',
      }),
    };
  };

  return (
    <div className="app-container">

      {/* Main Content */}
      <div className="main-content">
        {user && <CompactAttendanceBar />}
        {/* Header */}
        <motion.header
          className="main-header"
          initial={{ y: -50, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ duration: 0.5, delay: 0.2 }}
        >
          <div className="header-left">
            <h2>{formatTime().greeting}!</h2>
            <p className="current-time">{formatTime().date}</p>
          </div>

          <div className="header-right">
            <div className="search-bar">
              <i className="fas fa-search"></i>
              <input
                type="text"
                placeholder="Tìm kiếm chức năng..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                ref={searchInputRef}
              />
              {searchTerm && (
                <button className="clear-search" onClick={() => setSearchTerm('')}>
                  <i className="fas fa-times"></i>
                </button>
              )}

              {/* Search Results */}
              <AnimatePresence>
                {searchTerm.trim() !== '' && (
                  <motion.div
                    className="search-results"
                    initial={{ opacity: 0, y: 10 }}
                    animate={{ opacity: 1, y: 0 }}
                    exit={{ opacity: 0, y: 10 }}
                    transition={{ duration: 0.2 }}
                  >
                    <div className="search-results-list">
                      {searchResults.length > 0 ? (
                        <>
                          {/* Hiển thị kết quả tìm kiếm */}
                          {searchResults.filter(result => !result.isSuggestion).length > 0 && (
                            <div className="search-results-section">
                              <div className="search-results-section-header">
                                <h5>Kết quả tìm kiếm</h5>
                                <div className="search-indicators-legend">
                                </div>
                              </div>
                              {searchResults
                                .filter(result => !result.isSuggestion)
                                .map((result, index) => (
                                  <motion.div
                                    key={`result-${index}`}
                                    className={`search-result-item ${result.matchType ? `match-type-${result.matchType}` : ''}`}
                                    onClick={() => handleCardClick(result.path)}
                                    initial={{ opacity: 0, y: 10 }}
                                    animate={{ opacity: 1, y: 0 }}
                                    transition={{ delay: index * 0.05, duration: 0.2 }}
                                  >
                                    <div className="result-content">
                                      <h4>
                                        {result.title}
                                        {result.matchType === 'non-accent' && (
                                          <span className="match-indicator" title="Kết quả tìm kiếm không dấu">
                                          </span>
                                        )}
                                        {result.matchType === 'accent' && (
                                          <span className="match-indicator" title="Kết quả tìm kiếm có dấu">
                                          </span>
                                        )}
                                        {result.matchType === 'both' && (
                                          <span className="match-indicator" title="Kết quả tìm kiếm cả có dấu và không dấu">
                                          </span>
                                        )}
                                      </h4>
                                      <p>{result.description}</p>
                                      <span className="result-category">{result.category}</span>
                                    </div>
                                  </motion.div>
                                ))
                              }
                            </div>
                          )}

                          {/* Hiển thị gợi ý */}
                          {searchResults.filter(result => result.isSuggestion).length > 0 && (
                            <div className="search-results-section suggestions">
                              <div className="search-results-section-header">
                                <h5>Gợi ý cho bạn</h5>
                              </div>
                              {searchResults
                                .filter(result => result.isSuggestion)
                                .map((result, index) => (
                                  <motion.div
                                    key={`suggestion-${index}`}
                                    className="search-result-item suggestion"
                                    onClick={() => handleCardClick(result.path)}
                                    initial={{ opacity: 0, y: 10 }}
                                    animate={{ opacity: 1, y: 0 }}
                                    transition={{ delay: index * 0.05 + 0.2, duration: 0.2 }}
                                  >
                                    <div className="result-content">
                                      <h4>
                                        {result.title}
                                        <span className="match-indicator" title="Gợi ý">
                                        </span>
                                      </h4>
                                      <p>{result.description}</p>
                                      <span className="result-category">{result.category}</span>
                                    </div>
                                  </motion.div>
                                ))
                              }
                            </div>
                          )}
                        </>
                      ) : (
                        !isSearching && (
                          <div className="no-results">
                            <p>Không tìm thấy kết quả nào cho "{searchTerm}"</p>
                            <small>Thử tìm kiếm với từ khóa khác hoặc duyệt qua các chức năng bên dưới</small>
                          </div>
                        )
                      )}
                    </div>
                  </motion.div>
                )}
              </AnimatePresence>
            </div>
          </div>
        </motion.header>

        {/* Dashboard Content */}
        {activeTab === 'dashboard' && (
          <div className="dashboard-content">
            {/* Image Slider */}
            <motion.div
              className="image-slider-container"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: 0.3 }}
            >
              <Carousel
                autoPlay
                infiniteLoop
                showStatus={false}
                showThumbs={false}
                interval={5000}
                transitionTime={500}
                showArrows={true}
                emulateTouch={true}
                swipeable={true}
                dynamicHeight={false}
                className="welcome-slider"
                statusFormatter={(current, total) => `${current}/${total}`}
                renderIndicator={(onClickHandler, isSelected, index, label) => {
                  // Responsive indicator size based on screen width
                  const isMobile = window.innerWidth <= 576;
                  const isTablet = window.innerWidth <= 768 && window.innerWidth > 576;

                  let dotSize = '12px';
                  let dotMargin = '0 8px';

                  if (isTablet) {
                    dotSize = '10px';
                    dotMargin = '0 6px';
                  } else if (isMobile) {
                    dotSize = '8px';
                    dotMargin = '0 5px';
                  }

                  const defStyle = {
                    display: 'inline-block',
                    margin: dotMargin,
                    cursor: 'pointer',
                    width: dotSize,
                    height: dotSize,
                    borderRadius: '50%',
                    backgroundColor: isSelected ? 'var(--accent-color)' : 'rgba(255, 255, 255, 0.7)',
                    boxShadow: '0 0 5px rgba(17, 24, 39, 0.3)',
                    transition: 'all 0.3s ease'
                  };

                  const activeStyle = {
                    ...defStyle,
                    transform: 'scale(1.2)',
                    backgroundColor: 'var(--accent-color)'
                  };

                  return (
                    <button
                      type="button"
                      onClick={onClickHandler}
                      value={index}
                      key={index}
                      style={isSelected ? activeStyle : defStyle}
                      aria-label={`${label} ${index + 1}`}
                    />
                  );
                }}
              >
                {sliderData.map((slide, index) => (
                  <div className="slider-item" key={index}>
                    {/* Phương pháp 1: Sử dụng background-image */}
                    <div
                      className="slider-image"
                      style={{
                        backgroundImage: `url("${slide.image}"), url("${slide.imageAlt}"), url("${slide.imageAbs}"), ${slide.gradient}`,
                        backgroundSize: 'cover, cover, cover, cover',
                        backgroundPosition: 'center, center, center, center'
                      }}
                    ></div>

                    {/* Phương pháp 2: Sử dụng thẻ img với nhiều fallback */}
                    <img
                      src={slide.image}
                      alt={slide.title}
                      className="slider-img"
                      onError={(e) => {
                        // Thử đường dẫn thứ 2
                        e.target.src = slide.imageAlt;
                        e.target.onerror = (e2) => {
                          // Thử đường dẫn thứ 3
                          e.target.src = slide.imageAbs;
                          e.target.onerror = (e3) => {
                            // Cuối cùng sử dụng base64 image
                            e.target.src = slide.imageBase64;
                            e.target.onerror = null; // Ngăn lặp vô hạn
                          };
                        };
                      }}
                    />

                    {/* Phương pháp 3: Fallback gradient */}
                    <div
                      className="slider-fallback"
                      style={{ background: slide.gradient }}
                    ></div>
                    <div className="slider-content">
                      <h2>{slide.title}</h2>
                      <p>{slide.description}</p>
                      <button
                        className="slider-button"
                        onClick={(e) => {
                          e.stopPropagation();
                          navigate(slide.buttonLink);
                        }}
                        aria-label={slide.buttonText}
                      >
                        <span className="button-text">{slide.buttonText}</span>
                        <i className="fas fa-arrow-right" aria-hidden="true"></i>
                      </button>
                    </div>
                  </div>
                ))}
              </Carousel>
            </motion.div>

            {/* Quick Access */}
            <motion.div
              className="quick-access-section"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: 0.4 }}
            >
              <div className="section-header">
                <h2>Truy cập nhanh</h2>
                <div className="quick-access-info">
                  {favorites.length > 0 ? (
                    <span className="favorites-indicator">
                      <i className="fas fa-star"></i>
                      {favorites.length}/12 yêu thích
                    </span>
                  ) : (
                    <span className="default-indicator">
                      Mặc định theo vai trò
                    </span>
                  )}
                </div>
              </div>

              <div className="quick-access-grid">
                {quickAccessItems.map((item, index) => (
                  <motion.div
                    key={index}
                    className="quick-access-card"
                    whileHover={{ scale: 1.03, boxShadow: "0 10px 25px rgba(17, 24, 39, 0.1)" }}
                    whileTap={{ scale: 0.98 }}
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ delay: 0.5 + index * 0.1, duration: 0.3 }}
                  >
                    {/* Show remove button only if this item is in favorites */}
                    {isFavorited(item) && (
                      <button
                        className="quick-access-remove-btn"
                        onClick={(e) => {
                          e.stopPropagation();
                          toggleFavorite(item);
                        }}
                        data-tooltip-id="favorite-tooltip"
                        data-tooltip-content="Bỏ khỏi truy cập nhanh"
                      >
                        <i className="fas fa-times"></i>
                      </button>
                    )}

                    {/* Show favorite indicator if this item is favorited */}
                    {isFavorited(item) && (
                      <div className="quick-access-favorite-badge">
                        <i className="fas fa-star"></i>
                      </div>
                    )}

                    <div className="card-content" onClick={() => handleCardClick(item.path)}>
                      <div className="card-icon">
                        <i className={item.icon}></i>
                      </div>
                      <h3>{item.title}</h3>
                    </div>
                  </motion.div>
                ))}
              </div>
            </motion.div>

            {/* Super Admin System Quick Access */}
            {user?.role === 'SUPER_ADMIN' && (
              <motion.div
                className="quick-access-section super-admin-system-section"
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5, delay: 0.45 }}
              >
                <div className="section-header">
                  <h2>Quản trị hệ thống</h2>
                  <span className="super-admin-badge">SUPER ADMIN</span>
                </div>
                <div className="quick-access-grid">
                  {[
                    { path: '/superadmin', title: 'Quản lý tài khoản', icon: 'fas fa-user-shield' },
                    { path: '/activity-logs', title: 'Nhật ký hoạt động', icon: 'fas fa-history' },
                    { path: '/admin/announcements', title: 'Quản lý thông báo', icon: 'fas fa-bell' },
                    { path: '/link-management', title: 'Quản lý liên kết', icon: 'fas fa-link' },
                    { path: '/page-visibility', title: 'Hiển thị trang', icon: 'fas fa-eye' },
                    { path: '/system-status', title: 'Trạng thái hệ thống', icon: 'fas fa-server' },
                    { path: '/health-check', title: 'Health Check', icon: 'fas fa-heartbeat' },
                    { path: '/audit-trail', title: 'Audit Trail', icon: 'fas fa-shield-alt' },
                    { path: '/cron-dashboard', title: 'Cron Jobs', icon: 'fas fa-clock' },
                    { path: '/backup-manager', title: 'Quản lý Backup', icon: 'fas fa-database' },
                    { path: '/online-users', title: 'Người dùng trực tuyến', icon: 'fas fa-users' },
                    { path: '/software-rating-management', title: 'Đánh giá phần mềm', icon: 'fas fa-star-half-alt' },
                  ].map((item, index) => (
                    <motion.div
                      key={index}
                      className="quick-access-card system-card"
                      whileHover={{ scale: 1.03, boxShadow: "0 10px 25px rgba(220, 38, 38, 0.15)" }}
                      whileTap={{ scale: 0.98 }}
                      initial={{ opacity: 0, y: 20 }}
                      animate={{ opacity: 1, y: 0 }}
                      transition={{ delay: 0.5 + index * 0.05, duration: 0.3 }}
                    >
                      <div className="card-content" onClick={() => handleCardClick(item.path)}>
                        <div className="card-icon">
                          <i className={item.icon}></i>
                        </div>
                        <h3>{item.title}</h3>
                      </div>
                    </motion.div>
                  ))}
                </div>
              </motion.div>
            )}

            {/* Categories */}
            {SHOW_CATEGORIES_UI && (
              <motion.div
                className="categories-section"
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5, delay: 0.5 }}
              >
                <div className="section-header">
                  <h2>Danh mục chức năng</h2>
                  <button className="view-all-btn" onClick={() => setActiveTab('categories')}>
                    Xem tất cả <i className="fas fa-arrow-right"></i>
                  </button>
                </div>

                <div className="categories-grid">
                  {categories.slice(0, 6).map((category, index) => (
                    <motion.div
                      key={category.id}
                      className="category-card"
                      onClick={() => handleCategoryClick(category)}
                      whileHover={{ scale: 1.03, boxShadow: "0 10px 25px rgba(17, 24, 39, 0.1)" }}
                      whileTap={{ scale: 0.98 }}
                      initial={{ opacity: 0, y: 20 }}
                      animate={{ opacity: 1, y: 0 }}
                      transition={{ delay: 0.6 + index * 0.1, duration: 0.3 }}
                    >
                      <div className="category-icon">
                        <i className={category.icon}></i>
                      </div>
                      <h3>{category.title}</h3>
                      <p>{category.items.length} chức năng</p>
                    </motion.div>
                  ))}
                </div>
              </motion.div>
            )}
          </div>
        )}

        {/* Categories Tab */}
        {SHOW_CATEGORIES_UI && activeTab === 'categories' && (
          <div className="categories-content">
            <motion.div
              className="section-header"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5 }}
            >
              <h2>Tất cả danh mục</h2>
              <button
                className="back-to-home-btn"
                onClick={() => setActiveTab('dashboard')}
              >
                <i className="fas fa-home"></i> Quay về trang chủ
              </button>
            </motion.div>

            <div className="categories-list">
              {categories.map((category, index) => (
                <motion.div
                  key={category.id}
                  id={`category-${category.id}`}
                  className="category-section"
                  initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ delay: 0.1 * index, duration: 0.5 }}
                >
                  <div className="category-header">
                    <div className="category-title">
                      <div className="category-icon">
                        <i className={category.icon}></i>
                      </div>
                      <h3>{category.title}</h3>
                    </div>
                    <p>{category.items.length} chức năng</p>
                  </div>

                  <div className="category-items">
                    {category.items.map((item, itemIndex) => (
                      <motion.div
                        key={itemIndex}
                        className="function-card"
                        whileHover={{ scale: 1.02, boxShadow: "0 8px 20px rgba(17, 24, 39, 0.1)" }}
                        whileTap={{ scale: 0.98 }}
                        title={`${item.title} - ${item.description}`}
                      >
                        <div className="function-icon" title={`Biểu tượng: ${item.title}`}>
                          <i className={item.icon}></i>
                        </div>
                        <div className="function-info" onClick={() => handleCardClick(item.path)}>
                          <h4 title={item.title}>{item.title}</h4>
                          <p title={item.description}>{item.description}</p>
                        </div>
                        <div className="function-actions">
                          <button
                            className={`favorite-btn ${isFavorited(item) ? 'favorited' : ''}`}
                            onClick={(e) => {
                              e.stopPropagation();
                              toggleFavorite(item);
                            }}
                            data-tooltip-id="favorite-tooltip"
                            data-tooltip-content={isFavorited(item) ? 'Bỏ khỏi truy cập nhanh' : 'Thêm vào truy cập nhanh'}
                          >
                            <i className={isFavorited(item) ? 'fas fa-star' : 'far fa-star'}></i>
                          </button>
                          <div
                            className="function-action"
                            onClick={() => handleCardClick(item.path)}
                            title={`Truy cập ${item.title}`}
                          >
                            <i className="fas fa-chevron-right"></i>
                          </div>
                        </div>
                      </motion.div>
                    ))}
                  </div>
                </motion.div>
              ))}
            </div>
          </div>
        )}

        {/* Favorites Tab */}
        {activeTab === 'favorites' && (
          <div className="favorites-content">
            <motion.div
              className="section-header"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5 }}
            >
              <h2>Chức năng yêu thích</h2>
              <p className="favorites-count">
                {favorites.length > 0 ? `${favorites.length}/6 chức năng` : 'Chưa có chức năng yêu thích'}
              </p>
            </motion.div>

            {favorites.length > 0 ? (
              <div className="favorites-grid">
                {favorites.map((item, index) => (
                  <motion.div
                    key={index}
                    className="favorite-card"
                    onClick={() => handleCardClick(item.path)}
                    whileHover={{ scale: 1.03, boxShadow: "0 10px 25px rgba(17, 24, 39, 0.1)" }}
                    whileTap={{ scale: 0.98 }}
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ delay: index * 0.1, duration: 0.3 }}
                  >
                    <div className="favorite-header">
                      <div className="favorite-icon">
                        <i className={item.icon}></i>
                      </div>
                      <button
                        className="remove-favorite-btn"
                        onClick={(e) => {
                          e.stopPropagation();
                          toggleFavorite(item);
                        }}
                        data-tooltip-id="favorite-tooltip"
                        data-tooltip-content="Bỏ khỏi yêu thích"
                      >
                        <i className="fas fa-times"></i>
                      </button>
                    </div>
                    <h3>{item.title}</h3>
                    <p>{item.description || 'Chức năng yêu thích'}</p>
                    <div className="favorite-badge">
                      <i className="fas fa-star"></i>
                      <span>Yêu thích</span>
                    </div>
                  </motion.div>
                ))}
              </div>
            ) : (
              <div className="favorites-placeholder">
                <div className="placeholder-icon">
                  <i className="fas fa-star"></i>
                </div>
                <h3>Chưa có chức năng yêu thích</h3>
                <p>Các chức năng bạn đánh dấu yêu thích sẽ xuất hiện ở đây để truy cập nhanh hơn</p>
                <button className="browse-btn" onClick={() => setActiveTab('categories')}>
                  Duyệt danh mục
                </button>
              </div>
            )}
          </div>
        )}

        {/* Settings Tab */}
        {activeTab === 'settings' && (
          <div className="settings-content">
            <motion.div
              className="section-header"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5 }}
            >
              <h2>Cài đặt</h2>
            </motion.div>

            <div className="settings-grid">
              <div className="settings-card">
                <div className="settings-icon">
                  <i className="fas fa-user-circle"></i>
                </div>
                <h3>Thông tin cá nhân</h3>
                <p>Cập nhật thông tin cá nhân và tài khoản của bạn</p>
                <button className="settings-btn">Chỉnh sửa</button>
              </div>

              <div className="settings-card">
                <div className="settings-icon">
                  <i className="fas fa-bell"></i>
                </div>
                <h3>Thông báo</h3>
                <p>Quản lý cài đặt thông báo và nhắc nhở</p>
                <button className="settings-btn">Tùy chỉnh</button>
              </div>

              <div className="settings-card">
                <div className="settings-icon">
                  <i className="fas fa-palette"></i>
                </div>
                <h3>Giao diện</h3>
                <p>Thay đổi chủ đề và tùy chỉnh giao diện</p>
                <button className="settings-btn">Tùy chỉnh</button>
              </div>

              <div className="settings-card">
                <div className="settings-icon">
                  <i className="fas fa-shield-alt"></i>
                </div>
                <h3>Bảo mật</h3>
                <p>Quản lý mật khẩu và cài đặt bảo mật</p>
                <button className="settings-btn">Quản lý</button>
              </div>
            </div>
          </div>
        )}
      </div>

      {/* Tooltip for favorite buttons */}
      <Tooltip id="favorite-tooltip" place="top" />

      {/* Toast Notification */}
      <AnimatePresence>
        {showToast && (
          <motion.div
            className="toast-notification"
            initial={{ opacity: 0, y: 50, scale: 0.9 }}
            animate={{ opacity: 1, y: 0, scale: 1 }}
            exit={{ opacity: 0, y: 50, scale: 0.9 }}
            transition={{ duration: 0.3 }}
          >
            <div className="toast-content">
              <i className="fas fa-check-circle"></i>
              <span>{toastMessage}</span>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};

export default WelcomePage;
